/**
 *
 * This configuration file contains what is related
 * to environment variables. For that it is necessary
 * to have the corresponding .env.xxxx files (Ex: .env.development, etc)
 *
 */

/* eslint-disable global-require */
import defaultConfig from './default';

let config = { ...defaultConfig };

const env = process.env.NODE_ENV;

if (env === 'development') {
  config = { ...config, ...require('./development')?.default };
}

if (env === 'test') {
  config = { ...config, ...require('./test')?.default };
}

if (env === 'staging') {
  config = { ...config, ...require('./staging')?.default };
}

if (env === 'production') {
  config = { ...config, ...require('./production')?.default };
}

export default config;
